"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Popup = function Popup(_ref) {
  var children = _ref.children,
      point = _ref.point,
      size = _ref.size,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      place = _ref.place;
  var pop = (0, _react.useRef)(null);
  var beforeClass = '';

  if (point) {
    style.left = "".concat(point.pageX, "px");
    style.top = "".concat(point.pageY, "px");
  }

  if (size) {
    if (size.width) style.width = "".concat(size.width, "px");
    if (size.maxWidth) style.maxWidth = "".concat(size.maxWidth, "px");
    if (size.height) style.height = "".concat(size.height, "px");
  }

  if (point && size) {
    var realLeft = point.pageX + size.width;
    var realTop = point.pageY + size.height;

    if (realLeft > document.documentElement.clientWidth) {
      style.left = "".concat(point.pageX - size.width, "px");
      beforeClass = 'right';
    }

    if (realTop > document.documentElement.clientHeight) {
      style.top = "".concat(point.pageY - size.height, "px");
    }
  }

  (0, _react.useEffect)(function () {// Need to specify default size end points
    // console.log(pop, place);
  }, []);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "popup ".concat(beforeClass, " ").concat(place),
    style: style,
    ref: pop
  }, children);
};

var _default = Popup;
exports["default"] = _default;